import React from "react";
export const HeaderColor = React.createContext();
